import { useDispatch, useSelector } from "react-redux";

import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip
} from "@mui/material";

import EqualizerIcon from '@mui/icons-material/Equalizer';
import { BsSquareHalf } from 'react-icons/bs';
import ReplayIcon from '@mui/icons-material/Replay';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';


import { authSelector } from "../../../features/auth/authSlice";
import {
    displaySelector,
    setIsDisplaySidebar,
    setIsDisplayGraph,
    setStartResearch,
} from "../../../features/display/displaySlice";


import styles from "../../../styles/toolsbarGraph.module.css";

/** ------------------------------------------------------------------------  */  
const ToolsbarGraph = () => {
  const { isAuth } = useSelector(authSelector);
  const display = useSelector(displaySelector);
  
  const dispatch = useDispatch();

  const toggleDisplaySidebar = () => {
    dispatch(setIsDisplaySidebar( !display.isDisplaySidebar))
  }
  
  const toggleDisplayGraph = () => {
    dispatch(setIsDisplayGraph( !display.isDisplayGraph))
  }

  const startResearch = () => {
    dispatch(setStartResearch(true))
  }


  return (
    <>
    <nav className={styles.toolsbar}>
      {isAuth && (
        <List className={styles.navList}>

          <ListItem disablePadding>
            <ListItemButton onClick={() => startResearch()} className={styles.listTools}>
              <ListItemIcon className={styles.iconToolbar}>
                <Tooltip title="Lancer la recherche" placement="bottom" arrow>                
                  <IconButton>
                    <PlayCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          <div className={styles.vSeparator}></div>

          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleDisplaySidebar()} className={styles.listTools}>
              <ListItemIcon className={styles.iconToolbar}>
                <Tooltip title="Basculer la barre latèrale de gauche" placement="bottom" arrow>
                  <IconButton className={styles.btnSquare}>
                    <BsSquareHalf />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleDisplayGraph()} className={styles.listTools}>
              <ListItemIcon className={styles.iconToolbar}>
                <Tooltip title="Afficher/Masquer le graph" placement="bottom" arrow>
                  <IconButton>
                    <EqualizerIcon />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleDisplayGraph()} className={styles.listTools}>
              <ListItemIcon className={styles.iconToolbar}>
                <Tooltip title="Rafraichir le graph" placement="bottom" arrow>                
                  <IconButton>
                    <ReplayIcon />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

        </List>
      )}

    </nav>
    </>
  );
};

export default ToolsbarGraph;
  